import { render, staticRenderFns } from "./UserTicketsDialog.vue?vue&type=template&id=bb6fcae2&"
import script from "./UserTicketsDialog.vue?vue&type=script&lang=js&"
export * from "./UserTicketsDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserTicketsDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports